var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Heading from '@marketing/components/global/typography/Heading';
import { clsx } from 'clsx';
import { useEffect, useState } from 'react';
import { Link } from 'react-router';
import { ExplorePlans, LearnMore, OtherProducts, OurMeals } from '../MobileMenu';
import MoreInfo from '../MoreInfo';
import navContent from '../content';
import Flyout from './Flyout';
import NavigationLink from './NavigationLink';
var menuItemHeadings = [
    'Why Nom Nom',
    'Explore Plans',
    'Our Meals',
    'Other Products',
    'Learn More',
];
var MobileMenuItems;
(function (MobileMenuItems) {
    MobileMenuItems[MobileMenuItems["ExplorePlans"] = 1] = "ExplorePlans";
    MobileMenuItems[MobileMenuItems["OurMeals"] = 2] = "OurMeals";
    MobileMenuItems[MobileMenuItems["OtherProducts"] = 3] = "OtherProducts";
    MobileMenuItems[MobileMenuItems["LearnMore"] = 4] = "LearnMore";
})(MobileMenuItems || (MobileMenuItems = {}));
function MobileMenu(_a) {
    var isExpanded = _a.isExpanded, _b = _a.transitionDuration, transitionDuration = _b === void 0 ? 300 : _b, backgroundColorStyle = _a.backgroundColorStyle;
    var content = navContent.menus;
    var _c = useState(null), lastSelection = _c[0], setLastSelection = _c[1];
    var _d = useState(null), currentSelection = _d[0], setCurrentSelection = _d[1];
    useEffect(function () {
        if (!isExpanded)
            setCurrentSelection(null);
    }, [isExpanded]);
    var menuItems = menuItemHeadings.map(function (heading, index) {
        if (index === 0) {
            return (_jsx(Link, __assign({ to: "/why-nom-nom", viewTransition: true, onClick: function () {
                    setCurrentSelection(null);
                } }, { children: _jsx(Heading, __assign({ className: "!text-lg-nav-m md:!text-lg-nav-m !inline", size: "sm" }, { children: heading })) }), "menu-item-".concat(index)));
        }
        else {
            return (_jsx("div", __assign({ className: "h-full w-full box-border" }, { children: _jsx(NavigationLink, { label: heading, useIcon: true, onClick: function () {
                        if (index === currentSelection) {
                            setCurrentSelection(null);
                        }
                        else {
                            setCurrentSelection(index);
                            setLastSelection(index);
                        }
                    } }, "menu-item-".concat(index)) }), "menu-item-".concat(index)));
        }
    });
    var onBack = function () {
        setCurrentSelection(null);
    };
    return (_jsx("div", __assign({ className: clsx("w-full overflow-hidden transition-transform duration-".concat(transitionDuration, " pointer-events-auto ease-in-out"), !isExpanded ? 'translate-y-[-100%]' : 'translate-y-0', backgroundColorStyle) }, { children: _jsxs("div", __assign({ 
            // tailwind doesn't reliably handle dynamically-constructed utility classes, so using a style
            style: {
                transitionDelay: !isExpanded ? "".concat(transitionDuration, "ms") : '0ms',
            }, className: clsx("flex transition-transform duration-".concat(transitionDuration, " ease-in-out"), currentSelection > 0 ? 'translate-x-[-100%]' : 'translate-x-0') }, { children: [_jsxs("div", __assign({ style: {
                        height: 'calc(100vh - 64px)',
                    }, className: clsx('flex w-full shrink-0 flex-col justify-start items-start px-2xs-gutter py-8', "transition-transform duration-".concat(transitionDuration, " ease-in-out")) }, { children: [_jsx("div", __assign({ className: "flex w-full flex-col justify-between items-start gap-y-8 gap-x-8 pb-8" }, { children: menuItems })), _jsx("div", __assign({ className: "py-5" }, { children: _jsx(MoreInfo, { helpRoute: content.learnMore.helpRoute, contactRoute: content.learnMore.contactRoute }) }))] })), _jsx("div", __assign({ className: "w-full shrink-0" }, { children: _jsxs(Flyout, { children: [_jsx("div", __assign({ className: clsx(lastSelection === MobileMenuItems.ExplorePlans ? 'block' : 'hidden') }, { children: _jsx(ExplorePlans, { onBack: onBack, content: navContent.menus.explorePlans }) })), _jsx("div", __assign({ className: clsx(lastSelection === MobileMenuItems.OurMeals ? 'block' : 'hidden') }, { children: _jsx(OurMeals, { onBack: onBack, content: {
                                        meals: content.ourMeals.meals.mobile,
                                    } }) })), _jsx("div", __assign({ className: clsx(lastSelection === MobileMenuItems.OtherProducts ? 'block' : 'hidden') }, { children: _jsx(OtherProducts, { onBack: onBack, content: {
                                        probiotics: content.otherProducts.probiotics,
                                        treats: content.otherProducts.treats.mobile,
                                    } }) })), _jsx("div", __assign({ className: clsx(lastSelection === MobileMenuItems.LearnMore ? 'block' : 'hidden') }, { children: _jsx(LearnMore, { onBack: onBack, content: content.learnMore }) }))] }) }))] })) })));
}
export default MobileMenu;
